var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"await-loading"},[_c('mt-spinner',{staticClass:"loading-icon",attrs:{"slot":"value","type":_vm.type,"color":"#00B097"},slot:"value"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }